import { map, sortBy } from 'lodash';
import {
  QueryFunction,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';

import { QueryKey } from 'enums';
import { Bank } from 'types';
import { formatUtils } from 'utils';

export function useBanksQuery<TError>(
  queryKey: QueryKey,
  queryFn: QueryFunction<Bank[], QueryKey>,
  options?:
    | Omit<
        UseQueryOptions<Bank[], TError, Bank[], QueryKey>,
        'queryKey' | 'queryFn'
      >
    | undefined,
): UseQueryResult<Bank[]> {
  return useQuery(queryKey, queryFn, {
    ...options,
    select: (banks) =>
      map(sortBy(banks, ['archived', 'name']), (bank) => ({
        ...bank,
        name: formatUtils.formatName(bank),
      })),
  });
}
